import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IUser } from "./getMe";

// 사용자 수정 요청 인터페이스
export interface IUpdateStudentRequest {
  email?: string;
  password?: string;
  name?: string;
  role?: string;
  status?: string;
  grade?: number;
  is_graduated?: boolean;
  school?: string;
  phone?: string;
  parent_phone?: string;
  memo?: string;
  allow_early_submission?: boolean; // 조기 제출 허용 여부 (해외 학생용)
  group_id?: string;
}

/**
 * 사용자 정보 수정 API 함수
 * @param id 수정할 사용자의 ID
 * @param data 수정할 데이터
 * @returns API 응답
 */
export const apiUpdateStudent = async (
  id: string,
  data: IUpdateStudentRequest
) => {
  const response = await apiPatch<IUser>(`/users/${id}`, data);
  return response;
};

/**
 * 사용자 정보 수정 React Query 훅
 * @param id 수정할 사용자의 ID
 * @returns 뮤테이션 객체
 */
export const useUpdateStudent = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IUpdateStudentRequest) => apiUpdateStudent(id, data),
    onSuccess: () => {
      // 전체 사용자 목록과 특정 사용자 데이터 무효화
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.detail(id) });
    },
  });
};

export default useUpdateStudent;
